module.exports = __webpack_public_path__ + "static/media/Glass.4923240c.PNG";